import React from 'react'

import { palette } from '../../../styles/variables'
import Icon from '../../icon/Icon'
import { LoadingWheel } from '../../loading/Loading'
import exclaimIcon from '../../../styles/assets/exclamation-mark.svg'

import { VALID_STATUS } from './CompetitorTagInput'
import { ContentEditable } from './ContentEditable'
import { ReadOnlyTag, TagRemove, TagWrapper } from './styled'

export class SmartTag extends React.Component {
  innerEditableRef = React.createRef()

  remove = () => this.props.remove(this.props.index)

  render() {
    const {
      invalidTag,
      value,
      index,
      editable,
      inputRef,
      validator,
      update,
      readOnly,
      removeOnBackspace,
      testId = '',
    } = this.props

    return (
      <TagWrapper data-testid={testId} invalid={invalidTag}>
        {value.status === VALID_STATUS.validating && (
          <LoadingWheel width={16} height={16} color={palette.gray} />
        )}
        {value.status === VALID_STATUS.invalid && (
          <Icon src={exclaimIcon} size="16px" margin="0" />
        )}
        {!editable && <ReadOnlyTag>{value.domain}</ReadOnlyTag>}
        {editable && (
          <ContentEditable
            value={value.domain}
            inputRef={inputRef}
            innerEditableRef={this.innerEditableRef}
            change={(newValue) => update(index, newValue)}
            remove={this.remove}
            validator={validator}
            removeOnBackspace={removeOnBackspace}
          />
        )}
        <TagRemove
          data-testid="tag-remove"
          readOnly={readOnly}
          onClick={this.remove}
        />
      </TagWrapper>
    )
  }
}
